<template>
  <div>
    <div
      class="box text-center"
      :class="!box.caixaCompleta ? 'box-em-breve' : ''"
      @click="redirecionaCaixa(box.urlCaixa, box.caixaCompleta)"
    >
      <div
        class="d-grid iconTipoCaixa"
        v-if="box.caixaNova || box.destaque || box.desconto"
      ></div>
      <img :src="box.imagem" style="max-width: 200px; " class="productImage" />
      <div class="w-100 mt-2">
        <h4 class="nomeCaixa name-box">{{ box.nomeCaixa }}</h4>
      </div>
      <botaoDetalhe v-if="box.caixaCompleta" altura="70px"> </botaoDetalhe>
      <button class="btn-box badge-valor">
        {{ box.valor | currency }}
      </button>
    </div>
  </div>
</template>
<script>
import botaoDetalhe from './botao-detalhe.vue';
import { Badge } from '@/components';
export default {
  props: ['box'],
  components: { botaoDetalhe, Badge },
  methods: {
    redirecionaCaixa(caixa, caixaCompleta) {
      if (caixaCompleta) this.$router.push(`${caixa}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  border-radius: 16px;
  padding: 10px;
  min-height: 420px;
  transition: background-color 0.5s ease;

  &:hover {
    transition: 0.5s;
    margin-top: -10px;
  }

  .btn-box {
    border: none;
    font-weight: bold;
    padding: 10px 0;
    width: 80%;
    font-size: 16px;
    font-weight: 800;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    .img-box {
      width: 20px;
      margin-bottom: 3px;
    }
  }

  .name-box {
    font-weight: 600;
    margin-top: 60px;
  }

  .categoriasBox {
    color: #a7a7ff;
  }

  img {
    width: 100%;
  }

  .badge-valor {
    font-size: 1em;
    border-radius: 0rem;
    margin: 5px;
    padding: 0.35rem 0.7rem !important;
    line-height: 1.625rem !important;
    border: 0;
    transition: background-color 0.5s ease;
    font-weight: bold;
  }

  .botoes {
    display: flex;
    margin: 5px 0;
  }

  .btn {
    transition: background-image 0.5s ease;
    margin: 0px;
  }
  .iconTipoCaixa {
    display: block;
    position: absolute;
    width: 8% !important;
    margin-left: 2px;

    img {
      width: 80% !important;
      max-width: 30px;
      margin-left: 5px;
    }
  }
  .detalhe {
    visibility: hidden;
  }
}

.box-em-breve {
  img {
    filter: grayscale(1);
  }
}
</style>
